import { useCallback } from "react";
import { EOrderType, OrderActions, useOrderContext } from "../stores/OrderContext";

export const useOrderType = () => {
  const {
    dispatch,
    state: {
      flowData: { orderType },
    },
  } = useOrderContext();

  const isLimitOrder = orderType === EOrderType.limit;
  const oppositeOrderType = isLimitOrder ? EOrderType.market : EOrderType.limit;

  const setOrderType = useCallback<(type: EOrderType) => void>(
    (type) => {
      OrderActions.setOrderType(type, dispatch, "useOrderType.setOrderTypeCallback");
    },
    [dispatch]
  );

  return {
    orderType: orderType ?? EOrderType.default,
    setOrderType,
    oppositeOrderType,
    isLimitOrder,
  };
};
